import axios from 'axios';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { V_URL } from '../../../../BaseUrl';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import Footer from '../../Include/Footer';

const ManageSchedule = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state;

  const [form, setForm] = useState({
    schedule: "",
    size: "",
    thickness: ""
  });
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState('');
  const [selectValue, setSelectValue] = useState('');

  useEffect(() => {
    if (data?._id) {
      setForm({
        schedule: data?.schedule,
        size: data?.size,
        thickness: data?.thickness
      });
      setSelectValue(data?.status);
    }
  }, [data]);

  const handleRadioChange = (event) => {
    setSelectValue(event.target.checked);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = () => {
    if (validation()) {
      setDisable(true)
      const formData = new URLSearchParams();
      formData.append('schedule', form.schedule);
      formData.append('size', form.size);
      formData.append('thickness', form.thickness);
      if (data?._id) {
        formData.append('id', data?._id);
        formData.append('status', selectValue);
      }
      axios({
        method: "post",
        url: `${V_URL}/prosafe/manage-schedule-master`,
        data: formData,
        headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
      }).then((response) => {
        if (response.data.success === true) {
          navigate('/main-store/user/schedule-management');
          toast.success(response.data.message);
          setForm({
            schedule: "",
            size: "",
            thickness: ""
          })
        } else {
          toast.error(response.data.message);
        }
      }).catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        setDisable(false)
      })
    }
  }

  const validation = () => {
    var isValid = true;
    let err = {};
    if (!form.thickness || !form.thickness?.trim()) {
      isValid = false;
      err['thickness_err'] = "Please enter thickness"
    }
    if (!form.schedule || !form.schedule?.trim()) {
      isValid = false;
      err['schedule_err'] = "Please enter schedule"
    }
    if (!form.size || !form.size?.trim()) {
      isValid = false;
      err['size_err'] = "Please enter size"
    }
    setError(err);
    return isValid;
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>

      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">

          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/main-store/user/dashboard">Dashboard </Link></li>
                  <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                  <li className="breadcrumb-item"><Link to="/main-store/user/schedule-management">Schedule List</Link></li>
                  <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                  <li className="breadcrumb-item active">{data?._id ? 'Edit' : 'Add'} Schedule</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>{data?._id ? 'Edit' : 'Add'} Schedule Details</h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 col-md-4 col-xl-4">
                        <div className="input-block local-forms">
                          <label>Size(inch) <span className="login-danger">*</span></label>
                          <input className="form-control" type="text"
                            name='size' onChange={handleChange} value={form.size}
                          />
                          <div className='error'>{error.size_err}</div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-xl-4">
                        <div className="input-block local-forms">
                          <label>Schedule <span className="login-danger">*</span></label>
                          <input className="form-control" type="text"
                            name='schedule' onChange={handleChange} value={form.schedule}
                          />
                          <div className='error'>{error.schedule_err}</div>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-xl-4">
                        <div className="input-block local-forms">
                          <label>Thickness(mm) <span className="login-danger">*</span></label>
                          <input className="form-control" type="text"
                            name='thickness' onChange={handleChange} value={form.thickness}
                          />
                          <div className='error'>{error.thickness_err}</div>
                        </div>
                      </div>
                    </div>
                    {data?._id ? (
                      <div className='col-12 col-md-4 col-xl-4'>
                        <div className="cardNum">
                          <div className="mb-3">
                            <label htmlFor="fileUpload" className="form-label">Status</label>
                            <div className="form-check form-switch">
                              <input className="form-check-input" type="checkbox" role="switch" onChange={handleRadioChange} checked={selectValue} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="col-12">
                      <div className="doctor-submit text-end">
                        <button type="button"
                          className="btn btn-primary submit-form me-2" onClick={handleSubmit} disabled={disable}>{disable ? "Processing..." : (data?._id ? 'Update' : 'Submit')}</button>
                        <button type="button"
                          className="btn btn-primary cancel-form" onClick={() => setForm({ size: "", thickness: "", schedule: "" })}>Reset</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default ManageSchedule